import { MatSort } from "@angular/material/sort";
import { MemberPermissionSale } from "../../models/sales/membe-permission-sale.model";
import { MatDataSource } from "../../shared-new/util/mat-datasource";

export class SaleMemberAccessDataSource extends MatDataSource<MemberPermissionSale> {
  public constructor(data: MemberPermissionSale[], sort: MatSort) {
    super(data, sort);
  }
}
